// src/app/services/header.service.ts
import { inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private titleService = inject(Title);

  // Signal for the header title text
  title = signal<string | null>(null);

  // Signal for the header subtitle text
  subTitle = signal<string | null>(null);

  // Helper to set simple text
  setTitle(text: string) {
    this.title.set(text);

    // SEO Update
    this.titleService.setTitle(`${text} | My Company`);
  }

  // Helper to set raw HTML (like badges or dynamic IDs)
  setSubTitle(text: string) {
    this.subTitle.set(text);
  }
}
